import DriverAssetsApi from "../../services/api/DriverAssets";
import qs from "qs";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in driver Assets actions:", err);
}

export const setDriverAssetsIssuedList = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_ASSETS_ISSUED_LIST,
    payload,
  };
};

export const setActiveDriverTag = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_DRIVER_TAG,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DRIVER_ASSETS,
    payload,
  };
};

export const resetStates = (payload) => {
  return {
    type: ActionTypes.RESET_STATES_DRIVER_ASSETS,
    payload,
  };
};

export const setPaymentFlow = (payload) => {
  return {
    type: ActionTypes.SET_PAYMENT_FLOW,
    payload,
  };
};

export const setDriverCities = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_CITIES,
    payload,
  };
};

export const setDriverAssetsAvailableList = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_ASSETS_AVAILABLE_LIST,
    payload,
  };
};

export const setRecentAssetStatus = (payload) => {
  return {
    type: ActionTypes.SET_RECENT_ASSET_STATUS,
    payload,
  };
};

export const setOnboardingCenters = (payload) => {
  return {
    type: ActionTypes.SET_ONBOARDING_CENTERS,
    payload,
  };
};

export const setActiveFiltersDriverAssets = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_DRIVER_ASSETS,
    payload,
  };
};

export const getDriverAssetsIssuedList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
        ...filters,
      };
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
      });
      dispatch(setLoader(true));
      let response = await DriverAssetsApi.getDriverAssetsIssuedList(
        queryParamsString
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverAssetsIssuedList(response));
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFiltersDriverAssets(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverMetaData =
  (finalPayload = {}) =>
  async (dispatch) => {
    try {
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
      });
      dispatch(setLoader(true));
      let response = await DriverAssetsApi.getDriverMetaData(queryParamsString);
      dispatch(setLoader(false));
      if (response) {
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverCities =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
        ...filters,
      };
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
      });
      dispatch(setLoader(true));
      let response = await DriverAssetsApi.getDriverCities(queryParamsString);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverCities(response));
        return response.city;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getOnboardingCenters = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAssetsApi.getOnboardingCenters(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setOnboardingCenters(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverAssetsAvailableList =
  (finalPayload = {}) =>
  async (dispatch) => {
    try {
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
      });
      dispatch(setLoader(true));
      let response = await DriverAssetsApi.getDriverAssetsAvailableList(
        queryParamsString
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverAssetsAvailableList(response));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getRecentAssetStatus =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
        ...filters,
      };
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
      });
      dispatch(setLoader(true));
      let response = await DriverAssetsApi.getRecentAssetStatus(
        queryParamsString
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setRecentAssetStatus(response));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getTransactionStatus =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
        ...filters,
      };
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
      });
      let response = await DriverAssetsApi.getTransactionStatus(
        queryParamsString
      );
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const checkPaymentStatus = (payload) => async (dispatch) => {
  try {
    let response = await DriverAssetsApi.checkPaymentStatus(payload);
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const bulkUploadDriverAssets = (payload) => async (dispatch) => {
  try {
    let response = await DriverAssetsApi.bulkUploadDriverAssets(payload);
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const bulkUploadAssetsPickup = (payload) => async (dispatch) => {
  try {
    let response = await DriverAssetsApi.bulkUploadAssetsPickup(payload);
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const addDriverAssets = (payload, endpoint) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAssetsApi.addDriverAssets(payload, endpoint);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const verifyOtp = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAssetsApi.verifyOtp(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const resendOtp = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAssetsApi.resendOtp(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const initiatePayment = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAssetsApi.initiatePayment(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setPaymentFlow(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const discardAsset = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAssetsApi.discardAsset(payload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
